import CbCheckbox from './src/checkbox.vue';

CbCheckbox.install = function(Vue) {
  Vue.component(CbCheckbox.name, CbCheckbox);
};

export default CbCheckbox;
